module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/6-82b5133a22cad4ab4d7dd6aafa23f1d8.jpg";